import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import { getUserProfile } from '../api/me';
function Dashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  useEffect(() => {
    getUserProfile()
      .then((profile) => {
        console.log('User profile:', profile);
      })
      .catch((error) => {
        console.error('Error fetching user profile:', error);
      });
  }, []);
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

export default Dashboard;
